export const SUPPORTED_LOCALES = ['fr', 'en', 'es', 'zh', 'ja', 'ko'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const LOCALE_NAMES: Record<string, string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  zh: '繁體中文',
  ja: '日本語',
  ko: '한국어',
}

export function localeLanguageTag(locale: string) {
  return locale === 'zh' ? 'zh-TW' : locale
}

export function resolveSupportedLocale(
  value: unknown,
): SupportedLocale | undefined {
  const code = String(value || '')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0]
  return SUPPORTED_LOCALES.find((locale) => locale === code)
}
